import { connect } from 'react-redux'
import { getNodesByIds } from '../../core/selectors'
import { getNodeSelectionById } from '../../selection/selectors'
import { getConfigurationRoot } from '../selectors'
import ConfigurationRoot from '../components/configurationRoot'

const mapStateToProps = (state, ownProps) => ({
  handleClick: id => ownProps.history.push(`/konfiguration/${id}`),
  configurations: getNodesByIds({
    state,
    ids: getConfigurationRoot(state).children,
  }),
  parentSelection: getNodeSelectionById({
    state,
    id: getConfigurationRoot(state).id,
  }),
})

export default connect(
  mapStateToProps,
  null,
)(ConfigurationRoot)



// WEBPACK FOOTER //
// ./src/modules/configuration/containers/configurationRoot.js